import { render } from "./BaseFileLoader.vue?vue&type=template&id=1f59cbec"
import script from "./BaseFileLoader.vue?vue&type=script&lang=js"
export * from "./BaseFileLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__